import { Component, OnInit } from '@angular/core';
import { GetCurrenciesService } from 'src/app/shared/product/components/currency/getCurrencies.service';
import { StepOneBase } from 'src/app/shared/product/stepOne';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-reservation-step-one',
  templateUrl: './reservation-step-one.component.html',
  styleUrls: ['./reservation-step-one.component.scss']
})
export class ReservationStepOneComponent extends StepOneBase implements OnInit {

  isUpdate: any;
  id: any;
  productObject: any;

  constructor(protected getCurrencies : GetCurrenciesService,protected auth:AuthService) {
    super(getCurrencies,auth);
  }
  ngOnInit() {
    this.productName = 'Reservation';
    this.form = this.getForm(this.productName);

    this.stepForm = this.formValidator.createForm(this.form);
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
    this.stepForm.controls['TaxesQuestion'].valueChanges.subscribe(value => {
      this.isTaxesApplied = value;
      if (this.isTaxesApplied) {
        this.stepForm.controls['Taxes'].setValue(1);
      }
    });
  }

}
